<ng-container *ngIf="vm$ | async as vm">
    <ng-container *ngIf="multiBlog;else singleBlog">
        <div *ngFor="let blog of blogs">
            <ng-container *ngIf="blog.blogContentId == vm.blog.blogContentId">
                <nb-card>
                    <nb-card-header>{{ blog.contentName }}</nb-card-header>
                    <nb-list>
                        <nb-list-item *ngFor="let blogEntry of vm.blogEntries" (click)="selectBlogEntry(blogEntry)" >
                            <div *ngIf="blogEntry.ownerContentId === blog.blogContentId">
                                <p><strong>{{blogEntry.contentName}}</strong></p>
                                <p>{{blogEntry.description}}</p>
                            </div>
                        </nb-list-item>
                    </nb-list>
                </nb-card>
            </ng-container>
        </div>
        <nb-card>
            <nb-card-header>Other Topics</nb-card-header>
            <nb-list>
                <nb-list-item *ngFor="let blog of altBlogs">
                    <a routerLink="{{selectBlog(blog)}}">{{blog.contentName}}</a>
                </nb-list-item>
            </nb-list>
        </nb-card>
    </ng-container>
    <ng-template #singleBlog>
        <div *ngFor="let blogEntry of vm.blogEntries">
            <nb-card size="tiny" (click)="selectBlogEntry(blogEntry)" class="blogEntryMenu">
                <nb-card-body>
                    <h5>{{ blogEntry.contentName }}</h5>
                    <p>{{blogEntry.description}}</p>
                </nb-card-body>
            </nb-card>
        </div>
    </ng-template>
</ng-container>






